import React, { useCallback } from 'react';
import { Box, Stack, Divider, Chip } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

/**
 * 제조 상태 칩 컴포넌트
 * - 미시작 / 진행중 / 출고대기 / 출고완료 / 완료 / 종결
 *
 * value 는 백엔드(ManufacturingPlanMapper.xml 의 manufacturingStatusFilter)가 그대로
 * 알아듣는 상태 값이다. 라벨(화면 표시 문구)과 value(서버로 보내는 필터 값)가 다른 경우가
 * 있다 — 예: "출고대기" 라벨은 서버 판정값 "출하대기"를 가리킨다(하/고 표기 차이).
 * label 은 statusCounts(ManufacturingListContainer 에서 서버 응답을 이 라벨 체계로
 * 변환해 내려줌)를 찾는 키이기도 하다.
 */
const manufacturingStatus = [
  { id: 0, value: '', label: '전체', color: 'warning' },
  { id: 1, value: '미시작', label: '미시작', color: 'default' },
  { id: 2, value: '진행중', label: '진행중', color: 'primary' },
  { id: 3, value: '출하대기', label: '출고대기', color: 'warning' },
  { id: 4, value: '출고완료', label: '출고완료', color: 'success' },
  { id: 5, value: '완료', label: '완료', color: 'secondary' },
  { id: 6, value: '종결', label: '종결', color: 'error' },
];

const ManufacturingStatusChips = ({ filters, onFilters, statusCounts }) => {
  const handleFilterStatus = useCallback(
    (value) => {
      onFilters('statusFilter', value);
    },
    [onFilters],
  );

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItem: 'center',
        m: 1,
      }}
    >
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        spacing={2}
      >
        <Box>
          {manufacturingStatus &&
            manufacturingStatus.map((st, index) => {
              const count = statusCounts[st.label] || 0;
              return (
                <Chip
                  sx={{ mr: 1 }}
                  key={index}
                  icon={<CircleIcon />}
                  label={`${st.label} (${count})`}
                  variant={
                    st.value === filters?.statusFilter ? 'filled' : 'outlined'
                  }
                  color={st.color}
                  onClick={() => handleFilterStatus(st.value)}
                  size="small"
                />
              );
            })}
        </Box>
      </Stack>
    </Box>
  );
};

export default ManufacturingStatusChips;
